"use strict";
import { __exports as t } from "./index.es336.js";
var o;
function ae() {
  return o ? t : (o = 1, (function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function s(Ae, _) {
      for (var E in _) Object.defineProperty(Ae, E, {
        enumerable: !0,
        get: _[E]
      });
    }
    s(n, {
      ACTION_SUFFIX: function() {
        return d;
      },
      APP_DIR_ALIAS: function() {
        return V;
      },
      CACHE_ONE_YEAR: function() {
        return H;
      },
      DOT_NEXT_ALIAS: function() {
        return h;
      },
      ESLINT_DEFAULT_DIRS: function() {
        return Ee;
      },
      GSP_NO_RETURNED_VALUE: function() {
        return Z;
      },
      GSSP_COMPONENT_MEMBER_ERROR: function() {
        return ne;
      },
      GSSP_NO_RETURNED_VALUE: function() {
        return ee;
      },
      HTML_CONTENT_TYPE_HEADER: function() {
        return A;
      },
      INFINITE_CACHE: function() {
        return G;
      },
      INSTRUMENTATION_HOOK_FILENAME: function() {
        return v;
      },
      JSON_CONTENT_TYPE_HEADER: function() {
        return i;
      },
      MATCHED_PATH_HEADER: function() {
        return T;
      },
      MIDDLEWARE_FILENAME: function() {
        return r;
      },
      MIDDLEWARE_LOCATION_REGEXP: function() {
        return x;
      },
      NEXT_BODY_SUFFIX: function() {
        return D;
      },
      NEXT_CACHE_IMPLICIT_TAG_ID: function() {
        return l;
      },
      NEXT_CACHE_REVALIDATED_TAGS_HEADER: function() {
        return L;
      },
      NEXT_CACHE_REVALIDATE_TAG_TOKEN_HEADER: function() {
        return g;
      },
      NEXT_CACHE_SOFT_TAG_MAX_LENGTH: function() {
        return M;
      },
      NEXT_CACHE_TAGS_HEADER: function() {
        return f;
      },
      NEXT_CACHE_TAG_MAX_ITEMS: function() {
        return F;
      },
      NEXT_CACHE_TAG_MAX_LENGTH: function() {
        return m;
      },
      NEXT_DATA_SUFFIX: function() {
        return p;
      },
      NEXT_INTERCEPTION_MARKER_PREFIX: function() {
        return c;
      },
      NEXT_META_SUFFIX: function() {
        return O;
      },
      NEXT_QUERY_PARAM_PREFIX: function() {
        return a;
      },
      NEXT_RESUME_HEADER: function() {
        return X;
      },
      NON_STANDARD_NODE_ENV: function() {
        return re;
      },
      PAGES_DIR_ALIAS: function() {
        return U;
      },
      PRERENDER_REVALIDATE_HEADER: function() {
        return S;
      },
      PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER: function() {
        return u;
      },
      PUBLIC_DIR_MIDDLEWARE_CONFLICT: function() {
        return k;
      },
      ROOT_DIR_ALIAS: function() {
        return Y;
      },
      RSC_ACTION_CLIENT_WRAPPER_ALIAS: function() {
        return K;
      },
      RSC_ACTION_ENCRYPTION_ALIAS: function() {
        return j;
      },
      RSC_ACTION_PROXY_ALIAS: function() {
        return b;
      },
      RSC_ACTION_VALIDATE_ALIAS: function() {
        return B;
      },
      RSC_CACHE_WRAPPER_ALIAS: function() {
        return y;
      },
      RSC_DYNAMIC_IMPORT_WRAPPER_ALIAS: function() {
        return W;
      },
      RSC_MOD_REF_PROXY_ALIAS: function() {
        return w;
      },
      RSC_PREFETCH_SUFFIX: function() {
        return I;
      },
      RSC_SEGMENTS_DIR_SUFFIX: function() {
        return N;
      },
      RSC_SEGMENT_SUFFIX: function() {
        return C;
      },
      RSC_SUFFIX: function() {
        return P;
      },
      SERVER_PROPS_EXPORT_ERROR: function() {
        return z;
      },
      SERVER_PROPS_GET_INIT_PROPS_CONFLICT: function() {
        return q;
      },
      SERVER_PROPS_SSG_CONFLICT: function() {
        return J;
      },
      SERVER_RUNTIME: function() {
        return oe;
      },
      SSG_FALLBACK_EXPORT_ERROR: function() {
        return _e;
      },
      SSG_GET_INITIAL_PROPS_CONFLICT: function() {
        return Q;
      },
      STATIC_STATUS_PAGE_GET_INITIAL_PROPS_ERROR: function() {
        return $;
      },
      TEXT_PLAIN_CONTENT_TYPE_HEADER: function() {
        return R;
      },
      UNSTABLE_REVALIDATE_RENAME_ERROR: function() {
        return te;
      },
      WEBPACK_LAYERS: function() {
        return se;
      },
      WEBPACK_RESOURCE_QUERIES: function() {
        return Re;
      }
    });
    const R = "text/plain", A = "text/html; charset=utf-8", i = "application/json; charset=utf-8", a = "nxtP", c = "nxtI", T = "x-matched-path", S = "x-prerender-revalidate", u = "x-prerender-revalidate-if-generated", I = ".prefetch.rsc", N = ".segments", C = ".segment.rsc", P = ".rsc", d = ".action", p = ".json", O = ".meta", D = ".body", f = "x-next-cache-tags", L = "x-next-revalidated-tags", g = "x-next-revalidate-tag-token", X = "next-resume", F = 128, m = 256, M = 1024, l = "_N_T_", H = 31536e3, G = 4294967294, r = "middleware", x = `(?:src/)?${r}`, v = "instrumentation", U = "private-next-pages", h = "private-dot-next", Y = "private-next-root-dir", V = "private-next-app-dir", w = "private-next-rsc-mod-ref-proxy", B = "private-next-rsc-action-validate", b = "private-next-rsc-server-reference", y = "private-next-rsc-cache-wrapper", W = "private-next-rsc-track-dynamic-import", j = "private-next-rsc-action-encryption", K = "private-next-rsc-action-client-wrapper", k = "You can not have a '_next' folder inside of your public folder. This conflicts with the internal '/_next' route. https://nextjs.org/docs/messages/public-next-folder-conflict", Q = "You can not use getInitialProps with getStaticProps. To use SSG, please remove your getInitialProps", q = "You can not use getInitialProps with getServerSideProps. Please remove getInitialProps.", J = "You can not use getStaticProps or getStaticPaths with getServerSideProps. To use SSG, please remove getServerSideProps", $ = "can not have getInitialProps/getServerSideProps, https://nextjs.org/docs/messages/404-get-initial-props", z = "pages with `getServerSideProps` can not be exported. See more info here: https://nextjs.org/docs/messages/gssp-export", Z = "Your `getStaticProps` function did not return an object. Did you forget to add a `return`?", ee = "Your `getServerSideProps` function did not return an object. Did you forget to add a `return`?", te = "The `unstable_revalidate` property is available for general use.\nPlease use `revalidate` instead.", ne = "can not be attached to a page's component and must be exported from the page. See more info here: https://nextjs.org/docs/messages/gssp-component-member", re = 'You are using a non-standard "NODE_ENV" value in your environment. This creates inconsistencies in the project and is strongly advised against. Read more: https://nextjs.org/docs/messages/non-standard-node-env', _e = "Pages with `fallback` enabled in `getStaticPaths` can not be exported. See more info here: https://nextjs.org/docs/messages/ssg-fallback-true-export", Ee = [
      "app",
      "pages",
      "components",
      "lib",
      "src"
    ], oe = {
      edge: "edge",
      experimentalEdge: "experimental-edge",
      nodejs: "nodejs"
    }, e = {
      /**
      * The layer for the shared code between the client and server bundles.
      */
      shared: "shared",
      /**
      * The layer for server-only runtime and picking up `react-server` export conditions.
      * Including app router RSC pages and app router custom routes and metadata routes.
      */
      reactServerComponents: "rsc",
      /**
      * Server Side Rendering layer for app (ssr).
      */
      serverSideRendering: "ssr",
      /**
      * The browser client bundle layer for actions.
      */
      actionBrowser: "action-browser",
      /**
      * The Node.js bundle layer for the API routes.
      */
      apiNode: "api-node",
      /**
      * The Edge Lite bundle layer for the API routes.
      */
      apiEdge: "api-edge",
      /**
      * The layer for the middleware code.
      */
      middleware: "middleware",
      /**
      * The layer for the instrumentation hooks.
      */
      instrument: "instrument",
      /**
      * The layer for assets on the edge.
      */
      edgeAsset: "edge-asset",
      /**
      * The browser client bundle layer for App directory.
      */
      appPagesBrowser: "app-pages-browser",
      /**
      * The browser client bundle layer for Pages directory.
      */
      pagesDirBrowser: "pages-dir-browser",
      /**
      * The Edge Lite bundle layer for Pages directory.
      */
      pagesDirEdge: "pages-dir-edge",
      /**
      * The Node.js bundle layer for Pages directory.
      */
      pagesDirNode: "pages-dir-node"
    }, se = {
      ...e,
      GROUP: {
        builtinReact: [
          e.reactServerComponents,
          e.actionBrowser
        ],
        serverOnly: [
          e.reactServerComponents,
          e.actionBrowser,
          e.instrument,
          e.middleware
        ],
        neutralTarget: [
          // pages api
          e.apiNode,
          e.apiEdge
        ],
        clientOnly: [
          e.serverSideRendering,
          e.appPagesBrowser
        ],
        bundled: [
          e.reactServerComponents,
          e.actionBrowser,
          e.serverSideRendering,
          e.appPagesBrowser,
          e.shared,
          e.instrument,
          e.middleware
        ],
        appPages: [
          // app router pages and layouts
          e.reactServerComponents,
          e.serverSideRendering,
          e.appPagesBrowser,
          e.actionBrowser
        ]
      }
    }, Re = {
      edgeSSREntry: "__next_edge_ssr_entry__",
      metadata: "__next_metadata__",
      metadataRoute: "__next_metadata_route__",
      metadataImageMeta: "__next_metadata_image_meta__"
    };
  })(t), t);
}
export {
  ae as __require
};
//# sourceMappingURL=index.es312.js.map
